var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.031 13.808a.75.75 0 0 1-.684.442h-.5A2.25 2.25 0 0 1 6.597 12V9.75H3.751a1.75 1.75 0 0 1-1.653-2.322l1.557-4.5A1.75 1.75 0 0 1 5.31 1.75h8.538c.69 0 1.25.56 1.25 1.25v5c0 .69-.56 1.25-1.25 1.25h-1.765l-2.051 4.558zm2.316-6.058h1.25v-4.5h-1.25v4.5zm-1.5-4.5H5.31a.25.25 0 0 0-.236.168l-1.558 4.5a.25.25 0 0 0 .236.332h3.596a.75.75 0 0 1 .75.75v3c0 .414.336.75.75.75h.015l1.985-4.411V3.25z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsDown);
export default ForwardRef;